import svSE from 'antd/lib/locale-provider/sv_SE';
import enUS from 'antd/lib/locale-provider/en_US';
import plPL from 'antd/lib/locale-provider/pl_PL';
import i18n from './i18n';

export const getLanguage = () => {
  document.documentElement.lang = i18n.language;
  switch (i18n.language) {
    case 'sv':
    case 'sv-SE':
      return svSE;
    case 'pl':
    case 'pl-PL':
      return plPL;
    default:
      return enUS;
  }
};
